import { call, put, takeLatest } from 'redux-saga/effects';

import * as http from 'utils/http';

import { setFetching, setData, setChanging, setDataChange } from './duck';

// @effect Action
const loadAlerts$ = 'alerts/loadAlerts$';
const flushAlerts$ = 'alerts/flushAlerts$';
const changeAlertStatus$ = 'alerts/changeAlertStatus$';

// @effect Creators
export const loadAlerts = (payload) => ({
  type: loadAlerts$,
  payload,
});

export const flushAlerts = (payload) => ({
  type: flushAlerts$,
  payload,
});

export const changeAlertStatus = (payload) => ({
  type: changeAlertStatus$,
  payload,
});

// Workers
function* loadAndSetData({ item }) {
  const { id, get_alerts } = item;

  const { results } = yield call(http.get, get_alerts);
  yield put(setData({ id, data: results }));
}

function* handleAlertsLoad({ payload: { item } }) {
  const { id } = item;

  try {
    yield put(setFetching({ id, fetching: true }));
    yield call(loadAndSetData, { item });
  } catch (err) {
    yield call(http.getError, err);
  } finally {
    yield put(setFetching({ id, fetching: false }));
  }
}

function* handleAlertsFlush({ payload: { item } }) {
  const { id } = item;
  yield put(setData({ id, data: [] }));
}

function* handleChangeAlertStatus({ payload: { id, url, option } }) {
  try {
    yield put(setChanging({ changing: true }));
    const changedAlert = yield call(http.put, url, { status: option.value });

    yield put(setDataChange({ shipperOrderId: id, alert: changedAlert }));
  } catch (err) {
    console.log(err);
    yield call(http.getError, err);
  } finally {
    yield put(setChanging({ changing: false }));
  }
}

// Watchers
export function* watchAlerts() {
  yield takeLatest(loadAlerts$, handleAlertsLoad);
  yield takeLatest(flushAlerts$, handleAlertsFlush);
  yield takeLatest(changeAlertStatus$, handleChangeAlertStatus);
}
